'use client';

import { ThemeProvider as NextThemeProvider } from 'next-themes';
import {
  createSystem,
  defaultConfig,
  ChakraProvider,
  type SystemConfig,
} from '@chakra-ui/react';

import type { ReactNode, FC, JSX } from 'react';

import { Fonts } from './Font';
import { theme } from './chakraTheme';

interface IThemeProviderProps {
  fontComponent?: FC;
  children: ReactNode;
  theme?: Partial<SystemConfig>;
}

export function ThemeProvider({
  children,
  fontComponent,
  theme: themeProps,
}: IThemeProviderProps): JSX.Element {
  const FontComponent = fontComponent || Fonts;
  const themeConfig = createSystem(defaultConfig, theme, themeProps || {});

  return (
    <ChakraProvider value={themeConfig}>
      <FontComponent />
      <NextThemeProvider enableSystem={false} attribute='class'>
        {children}
      </NextThemeProvider>
    </ChakraProvider>
  );
}
